import DecryptageArticleModel from './DecryptageArticle.model';
import DecryptagePedagogicArticleModel from './DecryptagePedagogicArticle.model';

export default class FakeNews {
  constructor({
    title,
    decoding,
    pedagogic,
    question,
  }) {
    this.title = title;
    this.decoding = decoding;
    this.pedagogic = pedagogic;
    this.question = question;
  }

  getTitle() {
    return this.title ?? '';
  }

  getDecodingTitle() {
    return this.decoding?.title ?? '';
  }

  getDecodingArticles() {
    const articles = this.decoding?.nodes ? Object.values(this.decoding.nodes) : [];
    return articles.map((val) => new DecryptageArticleModel(val));
  }

  getDecodingLinkTitle() {
    return this.decoding?.link?.title;
  }

  getDecodingLinkUri() {
    return this.decoding?.link?.uri;
  }

  getDecodingLinkOptions() {
    return this.decoding?.link?.options ?? [];
  }

  getPedagogicTitle() {
    return this.pedagogic?.title ?? '';
  }

  getPedagogicArticles() {
    const values = this.pedagogic?.nodes || {};
    const articles = [];
    Object.entries(values).map((el) => articles.push(el[1]));
    return articles.map((val) => new DecryptagePedagogicArticleModel(val));
  }

  getPedagogicLinkTitle() {
    return this.pedagogic?.link?.title;
  }

  getPedagogicLinkUri() {
    return this.pedagogic?.link?.uri ? this.pedagogic?.link?.uri.replace(/internal:/, '') : '';
  }

  getPedagogicLinkOptions() {
    return this.pedagogic?.link?.options ?? [];
  }

  getQuestionTitle() {
    return this.question?.title || 'Est-il vrai que... ?';
  }

  getQuestionContent() {
    return this.question?.text || '';
  }

  getQuestionMaxChar() {
    return this.question?.maximum_caracter_text || '';
  }

  getMaximumCaracter() {
    return this.question?.maximum_caracter ?? 400;
  }

  getQuestionIcon() {
    return this.question?.icon && this.question?.icon !== 0 ? this.question?.icon : '';
  }

  getQuestionPopinTitle() {
    return this.question?.popin?.title || '';
  }

  getQuestionPopinContent() {
    return this.question?.popin?.text || '';
  }

  getQuestionPopinIcon() {
    return this.question?.popin?.icon && this.question?.popin?.icon !== 0 ? this.question?.popin?.icon : '';
  }
}
